import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import {
  Checkbox,
  Grid2,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
} from "@mui/material";
import React from "react";
import CommonButton from "../../../component/Button";
import { HandleSkeletion } from "../../../utils/constants";
import { CustomDiv } from "../../chat-bot/style";
import {
  DataFound,
  TableContainerBorder,
} from "../../common-components/StyledComponents";
import { CustomizeTableCell } from "../../jobs/style";

const CommonTable = ({
  data = [],
  columns = [],
  onSortChange,
  paginationProps = { count: 0, page: 1, onPageChange: () => {} },
  withPagination = false,
  withCheckbox = false,
  handleTableBodyData,
  loading,
  handleSingleSelect,
  checkSelected,
  handleSelectAll,
  marginTop,
  handleCustomCheckBox,
  handleWholeCustomCheckBox,
  loadingRowLength,
  customStyle,
  handleRowClick,
  textAlign = "start",
}) => {
  const { count, page, onPageChange } = paginationProps;
  const loadingLength = withCheckbox ? 1 : 0;

  return (
    <TableContainerBorder marginTop={marginTop} customStyle={customStyle}>
      <Table>
        <TableHead>
          <TableRow>
            {withCheckbox && (
              <CustomizeTableCell
                padding="checkbox"
                width={"4%"}
                textAlign={textAlign}
              >
                {handleWholeCustomCheckBox ? (
                  handleWholeCustomCheckBox(data, checkSelected)
                ) : (
                  <Checkbox
                    color="primary"
                    checked={
                      data &&
                      data.length !== 0 &&
                      data.every((row) =>
                        (checkSelected || []).some((item) => item.id === row.id)
                      )
                    }
                    onChange={handleSelectAll}
                  />
                )}
              </CustomizeTableCell>
            )}
            {columns.map((col, index) => (
              <CustomizeTableCell
                textAlign={col.textAlign}
                width={col.width}
                key={index}
                className={`sort-table-cell ${col.active ? "active" : ""}`}
                onMouseEnter={(e) =>
                  col?.sort && e.currentTarget.classList.add("active")
                }
                onMouseLeave={(e) =>
                  col?.sort && e.currentTarget.classList.remove("active")
                }
                style={{
                  color: "#475467",
                  padding: "16px",
                  minWidth: col.minWidth,
                }}
                sx={{
                  "& .sort-wrapper": {
                    display: col.active ? "inline-flex" : "none",
                  },
                  "&.active .sort-wrapper": {
                    display: "inline-flex",
                  },
                  "& .label-text": {
                    display: col.active ? "none" : "inline-flex",
                  },
                  "&.active .label-text": {
                    display: "none",
                  },
                  "&.active .sort-wrapper": {
                    display: "inline-flex",
                  },
                  "&.hover .sort-wrapper": {
                    display: "inline-flex",
                  },
                }}
              >
                <TableSortLabel
                  active={col?.sort}
                  className={"sort-wrapper"}
                  direction={col.direction}
                  onClick={() => onSortChange(col)}
                  sx={{
                    // display: "inline-flex",
                    // alignItems: "center",
                    "& .MuiTableSortLabel-icon": {
                      fill: col.active ? "#7F56D9" : "#6C6C6C !important",
                    },
                    ...(col.active && {
                      "& .MuiSvgIcon-root": {
                        width: "1rem",
                        height: "1rem",
                        stroke: "#7F56D9",
                        strokeWidth: 2,
                        fill: "none",
                      },

                      "& .MuiSvgIcon-root path": {
                        stroke: "#7F56D9",
                        strokeWidth: 3,
                      },
                    }),
                  }}
                >
                  <Typography variant="body2" fontWeight="600" color="#475467">
                    {col.name}
                  </Typography>
                </TableSortLabel>

                <Typography
                  className="label-text"
                  variant="body2"
                  fontWeight="600"
                  color="#475467"
                >
                  {col.name}
                </Typography>
              </CustomizeTableCell>
            ))}
          </TableRow>
        </TableHead>
        {loading ? (
          <>
            {Array.from({ length: loadingRowLength || 10 }).map((_, index) => (
              <TableRow>
                {Array.from({
                  length: columns.length + loadingLength,
                }).map((_, index) => (
                  <TableCell key={index}>
                    <HandleSkeletion height={30} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </>
        ) : (
          <TableBody>
            {data.length > 0 ? (
              data.map((row, rowIndex) => (
                <TableRow
                  key={rowIndex}
                  className={
                    withCheckbox &&
                    checkSelected.some((item) => item.id === row.id) &&
                    "selected-row-color"
                  }
                  onClick={() => (handleRowClick ? handleRowClick(row) : {})}
                >
                  {withCheckbox && (
                    <CustomizeTableCell
                      padding="checkbox"
                      textAlign={textAlign}
                    >
                      <CustomDiv
                        onClick={(e) => e.stopPropagation()}
                        cursor="auto"
                      >
                        {handleCustomCheckBox ? (
                          handleCustomCheckBox(checkSelected, row)
                        ) : (
                          <Checkbox
                            color="primary"
                            checked={checkSelected.some(
                              (item) => item.id === row.id
                            )}
                            onChange={() => {
                              handleSingleSelect(row);
                            }}
                          />
                        )}
                      </CustomDiv>
                    </CustomizeTableCell>
                  )}
                  {handleTableBodyData(row, rowIndex)}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} align="center">
                  <DataFound padding="10px" margin="auto">
                    <CustomDiv fontSize="20px">👋</CustomDiv>
                    {"No results found"}
                  </DataFound>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        )}
      </Table>

      {withPagination && (
        <Grid2 display="flex" justifyContent="space-between" sx={{ p: 2 }}>
          <CommonButton
            variant="outlined"
            border="#D0D5DD"
            color="#344054"
            fontWeight="600"
            value="Previous"
            padding="3px 10px"
            startIcon={<ArrowBackIcon />}
            onClick={() => {
              if (page > 1) {
                onPageChange(page - 1);
              }
            }}
            disabled={page === 1 || loading}
          />
          <Pagination
            count={count}
            page={page}
            onChange={(_, newPage) => onPageChange(newPage)}
            shape="rounded"
            color="primary"
            hideNextButton
            hidePrevButton
            disabled={loading}
          />
          <CommonButton
            variant="outlined"
            border="#D0D5DD"
            color="#344054"
            fontWeight="600"
            value="Next"
            padding="3px 10px"
            endIcon={<ArrowForwardIcon />}
            onClick={() => {
              if (page < count) {
                onPageChange(page + 1);
              }
            }}
            disabled={page === count || loading}
          />
        </Grid2>
      )}
    </TableContainerBorder>
  );
};

export default CommonTable;
